__turbopack_context__.v({
  "bottomRight": "CoffeeSticker-module-scss-module__7K2DMq__bottomRight",
  "coffeeSticker": "CoffeeSticker-module-scss-module__7K2DMq__coffeeSticker",
});
